// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"0faa25e3","194":"8b9a9620","199":"25b992c6","256":"428ca8f2","270":"120cab08","347":"3ea05d17","360":"76ac3e83","524":"20246d41","611":"5b61e13b","624":"d2a8a990","751":"57016783","853":"680a5b79","882":"63c81f8f","938":"61a57fff"}[chunkId] + ".chunk.js";
};